import React from "react";
import "./DownTriangleStyles.scss";

type Props = {
    isActive: boolean;
};

export const DownTriangle: React.FC<Props> = (props: Props) => {
    return <div className={"down-triangle" + (props.isActive ? " down-triangle--active" : "")} />;
};
